import z from 'zod';

export function contractingReviewVendorSchema(index) {
    return z.object({
        [`vendor-${index}`]: z
            .string()
            .refine((val) => val !== '-1' && !!val, 'Please select a vendor'),
        [`makeModel-${index}`]: z
            .string()
            .refine((val) => val !== '-1' && !!val, 'Please select a make/model'),
        [`quote-${index}`]: z.any().refine(val => !!val, 'Please select a file'),
        [`contractingOfficerComments-${index}`]: z.string().max(100, 'Maximum 100 characters'),
        [`files-${index}`]: z.array(z.any()).optional(),
        [`areqPricePerVehicle-${index}`]: z.number({ invalid_type_error: 'Price must be a number' })
            .refine((val) => val !== 0, { message: 'Price is required' })
            .refine((val) => val > 0, { message: 'Price must be a positive number' }),
        [`extendedShippingDays-${index}`]: z.coerce.number()
            .refine((val) => val >= 0, {
                message: 'Extended shipping days must be a non-negative number',
            }),
        [`shippingDays-${index}`]: z.object({
            base: z.number().int().min(0, 'Base shipping days must be a positive integer'),
            additional: z.number().int().min(0, 'Additional shipping days must be a positive integer'),
            extended: z.number().int().min(0, 'Extended shipping days must be a positive integer'),
        }),
        [`id-${index}`]: z.string().optional(),
    });
}

export function engineeringApprovalSchema(index) {
    return z.object({
        [`requisitionVendorQuoteId-${index}`]: z.coerce.number().optional(),
        [`isAcceptable-${index}`]: z.coerce.string().refine(val => val !== 'null', {
            message: 'A decision is required',
        }),
        [`engineeringComments-${index}`]: z.string().max(1000, 'Maximum 1000 characters'),
    }).transform(data => {
        return {
            requisitionVendorQuoteId: data[`requisitionVendorQuoteId-${index}`] || '',
            isAcceptable: data[`isAcceptable-${index}`] === 'acceptable',
            engineeringComments: data[`engineeringComments-${index}`] || ''
        };
    })
}